import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface Props {
  onChange?: (event: { target: { checked: boolean } }, checked: boolean) => void;
  label: string | React.ReactNode;
  checked: boolean;
  sameLevel?: boolean;
  disabled?: boolean;
}

const FieldsetCheckbox: React.FC<Props> = ({
  onChange,
  label,
  checked,
  sameLevel,
  disabled,
}: Props) => {
  const handleCheckedChange = (isChecked: boolean) => {
    if (!onChange) {
      return;
    }
    // Create a synthetic event that mimics a native checkbox change event
    // react-hook-form checks event.target.type to determine how to extract the value
    const syntheticEvent = {
      target: { checked: isChecked, type: 'checkbox' },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(syntheticEvent, isChecked);
  };

  return (
    <Label
      className={cn(
        'flex cursor-pointer items-start gap-2',
        sameLevel && '-mt-6',
        disabled && 'cursor-not-allowed opacity-50'
      )}
    >
      <Checkbox
        checked={checked}
        onCheckedChange={handleCheckedChange}
        disabled={disabled}
        className="mt-0.5 size-4"
      />
      <span className="text-sm leading-5">{label}</span>
    </Label>
  );
};

export default FieldsetCheckbox;
